import styled, { css } from 'styled-components';

import { size } from '../../layout/helpers';

interface IColumn {
  $grow?: boolean;
  $noShrink?: boolean;
  $noGrow?: boolean;
  $alignRightLg?: boolean;
  $alignRight?: boolean;
  $minWidthHack?: boolean;
  $stretch?: boolean;
}

export const Column = styled.div<IColumn>`
  flex: 0 1 auto;

  ${({ $grow }) =>
    $grow &&
    css`
      flex-grow: 1;
    `}

  ${({ $noShrink }) =>
    $noShrink &&
    css`
      flex-shrink: 0;
    `}

  ${({ $alignRight }) =>
    $alignRight &&
    css`
      display: flex;
      flex-direction: column;
      align-items: flex-end;
    `}

  ${({ $alignRightLg }) =>
    $alignRightLg &&
    css`
      ${(props) => props.theme.breakpoint.Lg} {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
      }
    `}

  ${({ $minWidthHack }) =>
    $minWidthHack &&
    css`
      min-width: 0;
    `}

  ${({ $stretch }) =>
    $stretch &&
    css`
      align-self: stretch;
    `}
`;

interface IColumns {
  $spacing?: number;
  $wrap?: boolean;
  $valign?: 'start' | 'center' | 'end';
  $align?: 'start' | 'center' | 'end';
  $alignSm?: 'start' | 'center' | 'end';
  $clearLtSm?: boolean;
  $clearLtMd?: boolean;
  $clearLtLg?: boolean;
  $equalWidth?: boolean;
}

export const Columns = styled.div<IColumns>`
  display: flex;
  align-items: flex-start;

  ${({ $valign }) =>
    $valign === 'end'
      ? css`
          align-items: flex-end;
          vertical-align: bottom;
        `
      : $valign === 'center'
        ? css`
            align-items: center;
            vertical-align: middle;
          `
        : css`
            align-items: flex-start;
            vertical-align: top;
          `}

  ${({ $align }) =>
    $align === 'end'
      ? css`
          justify-content: flex-end;
        `
      : $align === 'center'
        ? css`
            justify-content: center;
          `
        : css`
            justify-content: flex-start;
          `}

  ${({ $alignSm }) =>
    $alignSm === 'end'
      ? css`
          ${(props) => props.theme.breakpoint.Sm} {
            justify-content: flex-end;
          }
        `
      : $alignSm === 'center'
        ? css`
            ${(props) => props.theme.breakpoint.Sm} {
              justify-content: center;
            }
          `
        : css`
            ${(props) => props.theme.breakpoint.Sm} {
              justify-content: flex-start;
            }
          `}

  ${({ $spacing }) =>
    $spacing &&
    css`
      gap: ${size($spacing)};
    `}

  ${({ $wrap }) =>
    $wrap &&
    css`
      flex-wrap: wrap;
    `}

  ${({ $equalWidth }) =>
    $equalWidth &&
    css`
      & > ${Column} {
        flex: 1 1 100%;
      }
    `}

  ${({ $equalWidth, $spacing }) =>
    $equalWidth &&
    $spacing &&
    css`
      width: calc(100% + ${size($spacing)});
    `}

  ${({ $clearLtSm }) =>
    $clearLtSm &&
    css`
      ${(props) => props.theme.breakpoint.LtSm} {
        display: block;

        ${Column} {
          display: block;
        }
      }
    `}

  ${({ $clearLtMd }) =>
    $clearLtMd &&
    css`
      ${(props) => props.theme.breakpoint.LtMd} {
        display: block;

        ${Column} {
          display: block;
        }
      }
    `}

  ${({ $clearLtLg }) =>
    $clearLtLg &&
    css`
      ${(props) => props.theme.breakpoint.LtLg} {
        display: block;

        ${Column} {
          display: block;
        }
      }
    `}
`;
